import { type FunctionComponent } from 'react';
import { PlaceholderImage } from '../images/placeholder-image/placeholder-image.component';
import { imageGalleryWidth } from '../media-gallery/media-gallery.css';

const MediaGallery: FunctionComponent = () => (
	<div className="flex flex-col">
		{/* Brand Logo */}
		<PlaceholderImage className="hidden lg:flex rounded mx-auto" width={124} height={40} />
		<div className={`flex flex-col items-center mt-2 ${imageGalleryWidth}`}>
			{/* Hero Image */}
			<PlaceholderImage className="mb-2" width={450} height={450} />
			{/* Thumbnails */}
			<PlaceholderImage className="lg:hidden w-full rounded mb-3" height={90} />
			<div className="hidden lg:flex w-full justify-between">
				{Array.from({ length: 6 }).map((_, index) => (
					<PlaceholderImage key={index} className="rounded" width={70} height={70} />
				))}
			</div>
		</div>
	</div>
);

const ProductSummary: FunctionComponent = () => (
	<div className="flex flex-col">
		{/* Brand / Title */}
		<PlaceholderImage className="rounded mb-2 w-full" height={60} />
		{/* Model */}
		<PlaceholderImage className="rounded mb-2 w-1/2" height={15} />
		{/* Collection */}
		<PlaceholderImage className="rounded mb-2 w-3/4" height={25} />
		{/* Rating */}
		<PlaceholderImage className="rounded w-1/4" height={15} />
	</div>
);

const BuySection: FunctionComponent = () => (
	<div className="flex flex-col md:mt-3">
		{/* Price */}
		<PlaceholderImage className="rounded mb-3 w-20" height={36} />
		{/* Finish */}
		<PlaceholderImage className="rounded mb-3 w-50" height={24} />
		<div className="hidden lg:flex lg:flex-row lg:flex-wrap lg:justify-start mb-3">
			{Array.from({ length: 6 }).map((_, index) => (
				<PlaceholderImage key={index} className="rounded mr-2 mt-2" height={90} width={90} />
			))}
		</div>
		<PlaceholderImage className="lg:hidden rounded mb-3" height={48} />
		{/* Configs */}
		<PlaceholderImage className="rounded mb-3 w-50" height={24} />
		<div className="hidden lg:grid lg:grid-cols-2 lg:grid-rows-2 gap-2 mb-3">
			{Array.from({ length: 4 }).map((_, index) => (
				<PlaceholderImage key={index} className="rounded w-full" height={60} />
			))}
		</div>
		<PlaceholderImage className="lg:hidden rounded mb-3" height={48} />
		{/* Shipping */}
		<PlaceholderImage className="rounded mb-2" height={48} />
		{/* Add To Cart Button */}
		<PlaceholderImage className="rounded w-full" height={60} />
	</div>
);

export const ProductPageSkeleton: FunctionComponent = () => (
	<div className="flex flex-col md:max-w-7xl mx-auto md:mt-3" data-testid="product-page-skeleton">
		{/* Breadcrumbs */}
		<PlaceholderImage className="rounded mx-auto md:ml-0 md:mt-3 md:mx-3" height={30} width={400} />
		<div className="mb-3 md:mt-3 p-2 md:p-3">
			{/* Shipping To */}
			<div className="flex mb-2">
				<PlaceholderImage className="md:hidden rounded mx-auto" height={15} width={140} />
			</div>
			<div className="grid grid-cols-1 md:grid-cols-2 gap-x-3">
				<div className="order-1 md:order-none md:row-span-2">
					<MediaGallery />
				</div>
				<div className="order-none md:order-1">
					<ProductSummary />
				</div>
				<div className="order-2">
					<BuySection />
				</div>
			</div>
		</div>
	</div>
);
